import {TaskManagerService} from '../../libs/ui/src';

import {tmClient} from '../apiService';

const _TaskManagerService = new TaskManagerService({client: tmClient});
export {_TaskManagerService as TaskManagerService};
